import React from "react";
import { PRODUCTS } from "@/constants/testIds";
import { PRODUCT_COLLECTION } from "@/lib/products";

export const Products = () => {
  return (
    <section
      id="collection"
      data-testid={PRODUCTS.section}
      className="section bg-[#F9F8F6]"
    >
      <div className="container-wide">
        {/* Heading */}
        <div className="grid md:grid-cols-12 gap-8 md:gap-16 mb-20 md:mb-28">
          <div className="md:col-span-5">
            <span className="label-overline">The Collection</span>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[1] font-light text-[#1A1A1A]">
              Five categories.
              <br />
              <span className="italic text-[#8C7A6B]">One standard.</span>
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-[#5C5C5C] text-base sm:text-lg leading-relaxed max-w-xl">
              Every piece in our showroom is chosen for material integrity, design longevity,
              and suitability to the coastal climate. Browse our five core categories and request
              a private consultation for samples and trade pricing.
            </p>
          </div>
        </div>

        {/* Alternating large editorial sections */}
        <div className="space-y-28 md:space-y-40">
          {PRODUCT_COLLECTION.map((p, idx) => {
            const reversed = idx % 2 === 1;
            return (
              <article
                key={p.slug}
                data-testid={PRODUCTS.card(p.slug)}
                className="grid md:grid-cols-12 gap-8 md:gap-16 items-center"
              >
                <div className={`md:col-span-7 relative ${reversed ? "md:order-2" : ""}`}>
                  <div className="relative overflow-hidden grain">
                    <img
                      src={p.image}
                      alt={p.name}
                      className="w-full h-[480px] md:h-[600px] object-cover transition-transform duration-[1400ms] ease-out hover:scale-[1.03]"
                    />
                  </div>
                  <span className="absolute top-4 left-4 bg-[#F9F8F6]/95 px-3 py-1.5 label-overline">
                    0{idx + 1} / 05
                  </span>
                </div>

                <div className={`md:col-span-4 ${reversed ? "md:order-1 md:col-start-2" : "md:col-start-9"}`}>
                  <span className="label-overline">{p.tagline}</span>
                  <h3 className="font-heading text-4xl sm:text-5xl mt-4 font-light text-[#1A1A1A]">
                    {p.name}
                  </h3>
                  <p className="mt-6 text-[#5C5C5C] leading-relaxed">{p.description}</p>
                  <ul className="mt-8 space-y-3 border-t border-[#E5E0D8] pt-6">
                    {p.specs.map((s) => (
                      <li
                        key={s}
                        className="flex items-start gap-3 text-sm text-[#1A1A1A]"
                      >
                        <span className="mt-2 inline-block w-1.5 h-1.5 bg-[#B89F82]" />
                        {s}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
